<template>
  <v-footer
    id="home-footer"
    color="#282828"
    dark
    min-height="72"
  >
    <v-container>
      <v-row>
        <!-- <v-col
          cols="12"
          md="6"
        >
          <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
            <template v-for="(s, i) in social">
              <a
                :key="s"
                class="white--text pa-1 pa-md-0"
                href="#"
                v-text="s"
              />

              <v-responsive
                v-if="i < social.length - 1"
                :key="`divider-${s}`"
                class="mx-4 shrink hidden-sm-and-down"
                max-height="24"
              >
                <v-divider vertical />
              </v-responsive>
            </template>
          </div>
        </v-col> -->
        <v-col
          class="text-center text-md-center text-caption"
          cols="12"
        >
          Copyright © {{ currentYear }} YOOXPLORE TECHNOLOGY CO.LIMITED. All Rights Reserved.
        </v-col>
        <!-- ICP 备案号：仅在国内站构建时通过 VUE_APP_ICP 注入 -->
        <v-col
          v-if="icp"
          class="text-center text-md-center text-caption"
          cols="12"
        >
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            class="white--text"
          >
            {{ icp }}
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'HomeFooter',

    data: () => ({
      currentYear: new Date().getFullYear(),
      // 构建时由 VUE_APP_ICP 环境变量注入；海外站为空字符串则不渲染
      icp: process.env.VUE_APP_ICP || '',
      social: [
        'Facebook',
        'Twitter',
        'Instagram',
        'Linkedin',
      ],
    }),
  }
</script>

<style lang="sass">
  #home-footer a
    text-decoration: none
</style>
